import styled from "styled-components";

export const FunnelRatingContainer = styled.div`
  margin: 20px -5px;
`;
